
























































































































































































































































































































































import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator'
import TabelaDeFechamento from './TabelaDeFechamento.vue'
import { FechamentoDeCaixaDetalhado, MovimentacaoDeCaixa, TipoMovimentacao } from '@/models'
import TabelaDeMovimentacoes from './TabelaDeMovimentacoes.vue'
import DetalhesDePagamento from './DetalhesDePagamento.vue'
import ListaDeVendasDoFechamento from './ListaDeVendasDoFechamento.vue'
import { FindTurnoDeVendaUseCase, FindFechamentoDeCaixaUseCase } from '@/usecases'
import { imprimirFechamentoDeCaixa } from '@/shareds/fechamentos/impressao-do-fechamento-de-caixa'
import { imprimirDetalhado } from '@/shareds/fechamentos/impressao-detalhada'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import ImportadorDeArquivos from '@/views/application/fechamentosdecaixa/ImportadorDeArquivos.vue'
import DialogoDeNovaMovimentacao from '../DialogoDeNovaMovimentacao.vue'
import { criarMovimentacaoDeCaixa } from '@/shareds/venda-shareds'
import { MovimentarCaixaUseCase, SaveFechamentoDeCaixaUseCase } from '@/usecases'
import { formatarDataHora, formatarMoeda } from '@/shareds/formatadores'
import ItemDoResumo, { FluxoDeCaixa } from './ItemDoResumo.vue'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import request from '@/common/request'
import print from 'print-js'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'


interface AnexoComMetadata {
	nome: string
	nomeOriginal: string
	usuario: string
	tamanho?: number
	url: string
	baixando: boolean
	removendo: boolean
}

@Component({
	components: {
		TabelaDeFechamento,
		DetalhesDePagamento,
		ImportadorDeArquivos,
		TabelaDeMovimentacoes,
		DialogoDeNovaMovimentacao,
		ListaDeVendasDoFechamento,
		ItemDoResumo,
		SeletorDeUsuario,
	},
	data() {
		return {
			fechamentoDetalhado: undefined,
		}
	},
})
export default class DialogoDeDetalhesDeFechamento extends Vue {
	@Ref() dialogoDeImportadorDeArquivos!: ImportadorDeArquivos
	@Prop({ type: String}) idFechamento!: string

	mostra: boolean | null = null

	fechamentoDetalhado!: FechamentoDeCaixaDetalhado

	formatarDataHora = formatarDataHora
	formatarMoeda = formatarMoeda

	tab = null
	tabs = ['Resumo', 'Fechamento', 'Movimentações', 'Pagamentos', 'Vendas', 'Outros']
	movimentacaoInicial = criarMovimentacaoDeCaixa()
	movimentarCaixaUseCase = new MovimentarCaixaUseCase()
	findTurnoDeVendaUseCase = new FindTurnoDeVendaUseCase()
	findFechamentoUseCase = new FindFechamentoDeCaixaUseCase()
	mostrarDialogoDeNovaMovimentacao: boolean | null = null
	saveFechamentoDeCaixaUseCase = new SaveFechamentoDeCaixaUseCase()
	carregandoSalvar = false
	carregandoSalvarUsuario = false
	usuarioSelecionadoTemporario: any = null

	carregando = true
	erroAoCarregar: Error | null = null
	
	carregandoAnexos = false
	anexos: AnexoComMetadata[] = []
	dialogoRemocao = false
	anexoParaRemover: AnexoComMetadata | null = null
	indiceAnexoParaRemover: number | null = null
	removendoAnexo = false
	usuarioFechamentoOrigem: any = null

	async salvar(){
		this.carregandoSalvar = true

		try{

			if(this.fechamentoDetalhado.observacao && this.fechamentoDetalhado.observacao.length > 255){
				AlertModule.setError('A observação não pode ter mais que 255 caracteres.')
				return
			}

			await this.saveFechamentoDeCaixaUseCase.update(this.fechamentoDetalhado)

			AlertModule.setSuccess('Fechamento salvo com sucesso!')
		} catch(e){
			AlertModule.setError(e)
			this.carregandoSalvar = false
		} finally{
			this.carregandoSalvar = false
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	async salvarUsuario() {
		this.carregandoSalvarUsuario = true
		try {
			const anterior = this.usuarioFechamentoOrigem
			const novo = this.usuarioSelecionadoTemporario

			this.fechamentoDetalhado.usuarioFechamento = novo
			await this.saveFechamentoDeCaixaUseCase.update(this.fechamentoDetalhado)

			if (this.usuario) {
				await this.saveFechamentoDeCaixaUseCase.registrarLogDeAlteracaoDeUsuario(
					this.usuario.id,
					anterior,
					novo,
				)
			}

			this.usuarioFechamentoOrigem = novo
		} finally {
			this.carregandoSalvarUsuario = false
		}
	}

	get resumosPorMovimentacao(): FluxoDeCaixa[] {
		if (!this.fechamentoDetalhado) return []
		const totalMovimentadoEmLancamentos = this.fechamentoDetalhado.turnoDeVenda.movimentacoes
			.filter(movimentacao => movimentacao.tipoMovimentacao !== 'Abertura')
			.reduce(
				(total, movimentacao) => total + (movimentacao.tipoMovimentacao === 'Sangria' ? -movimentacao.valor : movimentacao.valor), 0,
			)
		const totalAbertura = this.fechamentoDetalhado.turnoDeVenda.movimentacoes
			.filter(({ tipoMovimentacao }) => tipoMovimentacao === 'Abertura')
			.map(({ valor }) => valor)[0]

		const valorEmDinheiro = this.fechamentoDetalhado.totaisPorForma
			.find(({ forma }) => forma === 'Dinheiro')?.valor || 0
		
		const totalSangria = this.fechamentoDetalhado.turnoDeVenda.movimentacoes
			.filter(({ tipoMovimentacao }) => tipoMovimentacao === 'Sangria')
			.reduce((total, movimentacao) => total + movimentacao.valor, 0)
		
		const totalFundoDeCaixa = valorEmDinheiro - totalSangria + totalAbertura

		return [
			{
				nome: 'Abertura',
				valor: totalAbertura,
				tipo: '+',
			},
			{
				nome: 'Movimentações',
				valor: totalMovimentadoEmLancamentos !== 0
					? totalMovimentadoEmLancamentos * -1
					: 0,
				tipo: '-',
			},
			{
				nome: 'Fundo de Caixa',
				valor: totalFundoDeCaixa,
				tipo: '=',
				notaDeCalculo: 'Valor em dinheiro - Sangria + Abertura de Caixa',
			},
			{
				nome: 'Total Esperado',
				valor: this.fechamentoDetalhado.totalEsperado,
				tipo: '=',
				notaDeCalculo: 'Total Faturado + Abertura - Sangria + Reforço',
			},
		]
	}

	mostraTextoDaMovimentacao({ motivo, tipoMovimentacao }: MovimentacaoDeCaixa) {
		if (!motivo) return tipoMovimentacao
		return `${motivo.nome}${!motivo.despesa && '*'}`
	}

	get resumosPorPagamento(): FluxoDeCaixa[] {
		if (!this.fechamentoDetalhado) return []
		return [
			...this.fechamentoDetalhado.totaisPorForma.map<FluxoDeCaixa>(
				({
					forma,
					valor,
				}) => ({
					nome: forma,
					valor,
					tipo: valor < 0 ? '-': '+',
					notaDeCalculo: 'Total por forma (exceto vendas canceladas)',
				}),
			),
			{
				nome: 'Troco',
				valor: Math.abs(this.fechamentoDetalhado.totalEmTrocos),
				tipo: -this.fechamentoDetalhado.totalEmTrocos >= 0 ? '+' : '-',
				notaDeCalculo: 'Total Faturado - Total pago (Cartão + Dinheiro + Outros)',
			},
			{
				nome: 'Taxas',
				valor: Math.abs(this.fechamentoDetalhado.totalEmTaxas),
				tipo: '+',
				notaDeCalculo: 'Apenas taxas',
			},
			{
				nome: 'Total Faturado',
				valor: this.fechamentoDetalhado.totalEmVendas,
				tipo: '=',
				notaDeCalculo: 'Soma das vendas (considerando descontos + taxas)',
			},
		]
	}

	get resumosDoCaixa(): FluxoDeCaixa[] {
		if (!this.fechamentoDetalhado) return []
		return [
			{
				nome: 'Total no Caixa',
				valor: this.fechamentoDetalhado.totalContado,
				tipo: '=',
				notaDeCalculo: 'Valor apontado na caixa registradora',
			},
			{	
				nome: 'Diferença',
				valor: this.fechamentoDetalhado.totalDeDiferenca,
				tipo: '=',
				notaDeCalculo: 'Total no Caixa - Total Esperado',
			},
		]
	}

	get totalSemDespesa() {
		const total = this.fechamentoDetalhado.turnoDeVenda.movimentacoes.reduce(
			(total, movimentacao) => {
				if (!movimentacao.motivo || movimentacao.motivo.despesa) return total
				return movimentacao.tipoMovimentacao === 'Sangria'
					? movimentacao.valor
					: -movimentacao.valor
			},
			0,
		)
		return total
	}

	get resumoDoTotalDeVendasCanceladas(): FluxoDeCaixa | null {
		if (!this.fechamentoDetalhado) return null
		return {
			nome: 'Vendas Canceladas',
			valor: this.fechamentoDetalhado.totalEmVendasCanceladas,
			tipo: '-',
			notaDeCalculo: 'Vendas canceladas, tanto durante quanto fora do turno de vendas, devem ser observadas, lembrando que aquelas canceladas fora do turno ainda serão registradas no fechamento',
		}
	}

	async reimprimirFechamentoDeCaixa(){
		const turnoDeVenda = (await this.findTurnoDeVendaUseCase.find({ fechamento: this.idFechamento })).content[0]
		try {
			await imprimirFechamentoDeCaixa(turnoDeVenda, this.fechamentoDetalhado)
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async imprimirDetalhado(){
		const turnoDeVenda = (await this.findTurnoDeVendaUseCase.find({ fechamento: this.idFechamento })).content[0]
		try {
			await imprimirDetalhado(turnoDeVenda, this.fechamentoDetalhado)
		} catch (e) {
			AlertModule.setError(e)
		}
	}
	
	mostrarDialogoDeUploadDeArquivos() {
		this.dialogoDeImportadorDeArquivos.mostrar(this.fechamentoDetalhado)
	}
	
	abrirDialogoDeNovaMovimentacaoDeCaixa(tipo: TipoMovimentacao) {
		this.movimentacaoInicial.tipoMovimentacao = tipo
		this.mostrarDialogoDeNovaMovimentacao = true
	}
	
	async atualizaTurnoDeFechamento() {
		this.fechamentoDetalhado = await this.findFechamentoUseCase.get(this.idFechamento)
	}

	async carregar() {
		try {
			this.carregando = true
			this.fechamentoDetalhado = await this.findFechamentoUseCase.get(this.idFechamento)
			this.usuarioFechamentoOrigem = this.fechamentoDetalhado?.usuarioFechamento ?? null
			await this.carregarAnexos()
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async carregarAnexos() {
		if (!this.fechamentoDetalhado?.anexos || this.fechamentoDetalhado.anexos.length === 0) {
			this.anexos = []
			return
		}

		try {
			this.carregandoAnexos = true
			
			const anexosComMetadata = await Promise.all(
				this.fechamentoDetalhado.anexos.map(async (nomeArquivo) => {
					const ultimaPosicaoUnderline = nomeArquivo.lastIndexOf('_')

					let nomeArquivoFormatado = nomeArquivo
					let nomeUsuario = ''

					if (ultimaPosicaoUnderline !== -1) {
						nomeArquivoFormatado = nomeArquivo.substring(0, ultimaPosicaoUnderline)
						nomeUsuario = nomeArquivo.substring(ultimaPosicaoUnderline + 1)
					}

					return {
						nome: nomeArquivoFormatado,
						nomeOriginal: nomeArquivo,
						usuario: nomeUsuario,
						baixando: false,
						removendo: false,
						url: '',
					}
				}),
			)
			
			this.anexos = anexosComMetadata
		} catch (error) {
			AlertModule.setError('Erro ao carregar anexos: ' + error)
		} finally {
			this.carregandoAnexos = false
		}
	}

	confirmarRemocaoAnexo(anexo: AnexoComMetadata, index: number) {
		this.anexoParaRemover = anexo
		this.indiceAnexoParaRemover = index
		this.dialogoRemocao = true
	}

	async removerAnexo() {
		if (this.anexoParaRemover === null || this.indiceAnexoParaRemover === null) return

		try {
			this.removendoAnexo = true
			
			const novosAnexos = [...this.fechamentoDetalhado.anexos]
			novosAnexos.splice(this.indiceAnexoParaRemover, 1)
			
			const fechamentoAtualizado = {
				...this.fechamentoDetalhado,
				anexos: novosAnexos,
			}
			
			await this.saveFechamentoDeCaixaUseCase.update(fechamentoAtualizado)
			this.fechamentoDetalhado.anexos = novosAnexos
			
			this.anexos = []
			
			AlertModule.setSuccess('Anexo removido com sucesso!')
			this.dialogoRemocao = false
			this.carregar()
		} catch (error) {
			AlertModule.setError('Erro ao remover anexo: ' + error)
		} finally {
			this.removendoAnexo = false
			this.anexoParaRemover = null
			this.indiceAnexoParaRemover = null
		}
	}

	getFileIcon(nomeArquivo: string): string {
		const extensao = nomeArquivo.split('.').pop()?.toLowerCase()
		
		switch (extensao) {
			case 'pdf':
				return 'mdi-file-pdf-box'
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'bmp':
				return 'mdi-file-image'
			case 'doc':
			case 'docx':
				return 'mdi-file-word'
			case 'xls':
			case 'xlsx':
				return 'mdi-file-excel'
			case 'txt':
				return 'mdi-file-document'
			case 'zip':
			case 'rar':
			case '7z':
				return 'mdi-folder-zip'
			default:
				return 'mdi-file'
		}
	}

	getIconColor(nomeArquivo: string): string {
		const extensao = nomeArquivo.split('.').pop()?.toLowerCase()
		
		switch (extensao) {
			case 'pdf':
				return 'red'
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'bmp':
				return 'blue'
			case 'doc':
			case 'docx':
				return 'blue darken-2'
			case 'xls':
			case 'xlsx':
				return 'green'
			case 'txt':
				return 'grey'
			case 'zip':
			case 'rar':
			case '7z':
				return 'orange'
			default:
				return 'grey darken-1'
		}
	}

	formatarTamanho(bytes?: number): string {
		if (!bytes) return 'Tamanho desconhecido'
		
		const kb = bytes / 1024
		if (kb < 1024) return `${kb.toFixed(2)} KB`
		
		const mb = kb / 1024
		if (mb < 1024) return `${mb.toFixed(2)} MB`
		
		const gb = mb / 1024
		return `${gb.toFixed(2)} GB`
	}

	@Watch('mostra')
	async onChangeMostra(mostra: boolean) {
		if (!mostra) return
		this.carregar()
	}

	@Watch('fechamentoDetalhado', { deep: true })
	onChangeFechamento(fechamento: FechamentoDeCaixaDetalhado | null) {
		this.$emit('input', fechamento)
		this.usuarioSelecionadoTemporario = fechamento?.usuarioFechamento ?? null
	}

	async baixarArquivo(caminhoDaPasta: string, anexo: AnexoComMetadata) {
		this.$set(anexo, 'baixando', true)
		try {
			const pattern = /[\s~`!@#$%^&*()áÁàÀ\-+={}[\]|\\;:'",<>/?]+/g
			if (pattern.test(anexo.nome)) {
				AlertModule.setInfo("Parece que o arquivo salvo continha espaços e/ou caracteres especiais. O arquivo anexado poderá estar corrompido. Nesses casos, será necessário anexar o arquivo novamente!")
			}
			await this.downloadFilesFromS3(caminhoDaPasta, anexo.nome, anexo.nomeOriginal)
		} catch (error) {
			AlertModule.setError('Houve um problema ao baixar o arquivo: ' + error)
		} finally {
			this.$set(anexo, 'baixando', false)
		}
	}

	async downloadFilesFromS3(caminhoDaPasta: string, nomeDoArquivo: string, nomeOriginal: string) {
		const extensaoDoArquivo = decodeURIComponent(
			nomeDoArquivo.substring(nomeDoArquivo.lastIndexOf('.') + 1),
		)
		const presignedUrl = await request.post<{fileName: string; contentType: string }, string>('/pre-signed-url', {
			fileName: nomeOriginal,
			folderName: caminhoDaPasta,
			contentType: extensaoDoArquivo,
			httpMethod: 'GET',
		})

		if (extensaoDoArquivo === 'pdf') {
			await Promise.race([
				new Promise<void>((resolve, reject) => {
					print({
						documentTitle: nomeDoArquivo,
						printable: presignedUrl,
						onError: (error) => reject(error),
						onLoadingEnd: () => resolve(),
					})
				}),
				new Promise<never>((_, reject) =>
					setTimeout(() => reject(new Error('Erro ao fazer download do arquivo.')), 15000),
				),
			])
			return
		}

		const link = document.createElement('a')
		link.href = presignedUrl
		link.download = nomeDoArquivo
		link.target = '_blank'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)		
	}

	get descricaoFechamento() {
		const data = this.formatarDataHora(this.fechamentoDetalhado.dataHoraFechamento)
		const operador = this.fechamentoDetalhado.usuarioOperador

		return operador ? `${data} Operador: ${operador}` : data
	}
}

